import getInstance from "../config/api";

export default class Client {
  static async fetchClients(params) {
    const instance = getInstance();
    const { data } = await instance.get("/clients", { params });
    return data;
  }

  static async fetchClientById(id) {
    const instance = getInstance();
    const { data } = await instance.get(`/clients/${id}`);
    return data;
  }

  static async updateClientManualApprovalCaf(id) {
    const instance = getInstance();
    const { data } = await instance.put(`/clients/manual-approval-caf/${id}`);
    return data;
  }

  static async updateClient(id, body) {
    const instance = getInstance();
    const { data } = await instance.put(`/clients/${id}`, body);
    return data;
  }

  static async disableClient(id) {
    const instance = getInstance();
    const { data } = await instance.patch(`/clients/${id}`);
    return data;
  }

  static async downloadClients(params) {
    const instance = getInstance();
    const data = await instance.get(`/clients/export`, { params });
    return data;
  }

  static async fetchClientIdByPrimaryDocument(primaryDocument) {
    const instance = getInstance();

    const { data } = await instance.get(`/clients/client-primary-document`, {
      params: { primaryDocument },
    });

    return data;
  }
}
